import { render } from "./NotificationView.vue?vue&type=template&id=a08d5a9c&scoped=true"
import script from "./NotificationView.vue?vue&type=script&lang=js"
export * from "./NotificationView.vue?vue&type=script&lang=js"

import "./NotificationView.vue?vue&type=style&index=0&id=a08d5a9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a08d5a9c"]])

export default __exports__